import { render, staticRenderFns } from "./AscDerivedParameterGridWrapper.vue?vue&type=template&id=4937a948&"
import script from "./AscDerivedParameterGridWrapper.vue?vue&type=script&lang=js&"
export * from "./AscDerivedParameterGridWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscDerivedParameterGridWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports